import { useContext } from 'react';
import { TenantThemeContext } from 'src/careflow/ph-core/multi-tenant/tenant/context/TenantThemeContext';

const useTenantTheme = () => {
  const context = useContext(TenantThemeContext);

  return context;
};

export default useTenantTheme;
